import React from 'react';
import styles from './map-tooltip.module.scss';

const MapTooltip = ({ children, position, visible, isStatic }) => {
  const style = {
    display: visible ? 'block' : 'none',
  };

  if (isStatic) {
    style.bottom = 10;
    style.right = 10;
    style.left = 'auto';
    style.top = 'auto';
  } else {
    style.left = position.x;
    style.top = position.y;
    style.transform = 'translate(-50%, -120%)';
  }

  return (
    <div style={style} className={styles.tooltip}>
      {children}
    </div>
  );
};

export default MapTooltip;



// WEBPACK FOOTER //
// ./src/components/map-tooltip/map-tooltip.js